export default __webpack_public_path__ + "static/FoundersGrotesk-Bold-b40f84fe14e380c9f7ff8f4fc1279270.woff";